import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Day } from '@app/forms/formly/types/range-picker-dropdown/range-picker/range-picker.component';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'range-picker-calendar',
  templateUrl: './range-picker-calendar.component.html',
  styleUrls: ['./range-picker-calendar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ReactiveFormsModule],
})
export class RangePickerCalendarComponent {
  @Input() days: Day[] = [];
  @Input() year: number;

  @Output() selectDate = new EventEmitter<Day>();

  protected readonly daysOfWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
}
